import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    { staticClass: "overflow-hidden", attrs: { flat: "" } },
    [
      _c(
        VAppBar,
        {
          staticClass: "pa-2",
          attrs: {
            absolute: "",
            "elevate-on-scroll": "",
            "scroll-target": "#scrolling-techniques-7",
          },
        },
        [
          _c(VCheckbox, {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.treeview.length > 0,
                expression: "treeview.length > 0",
              },
            ],
            staticClass: "ml-4",
            attrs: { color: _vm.cor },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function () {
                  return [
                    _c(
                      VTooltip,
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function ({ on: onTooltip }) {
                              return [
                                _c("span", _vm._g({}, { ...onTooltip }), [
                                  _vm._v("Selecionar Todos"),
                                ]),
                              ]
                            },
                          },
                        ]),
                      },
                      [_c("span", [_vm._v("Clique para selecionar todos")])]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.value.todos,
              callback: function ($$v) {
                _vm.$set(_vm.value, "todos", $$v)
              },
              expression: "value.todos",
            },
          }),
          _c(VSwitch, {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.treeview.length > 0 && !_vm.value.resumir,
                expression: "treeview.length > 0 && !value.resumir",
              },
            ],
            staticClass: "ml-4",
            attrs: { color: _vm.cor, dense: "" },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function () {
                  return [
                    _c(
                      VTooltip,
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function ({ on: onTooltip }) {
                              return [
                                _c("span", _vm._g({}, { ...onTooltip }), [
                                  _vm._v("Expandir Lista"),
                                ]),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "Clique para expandir ou recolher os itens da lista"
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.value.expandir,
              callback: function ($$v) {
                _vm.$set(_vm.value, "expandir", $$v)
              },
              expression: "value.expandir",
            },
          }),
          _vm._t("toolbar"),
          _c(VSpacer),
          _c(
            VTooltip,
            {
              attrs: { top: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on: onTooltip }) {
                    return [
                      _c(
                        VTextField,
                        _vm._g(
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.treeview.length > 0,
                                expression: "treeview.length > 0",
                              },
                            ],
                            staticClass: "ml-4",
                            attrs: {
                              label: "Pesquisar",
                              placeholder: "Digite para pesquisar...",
                              "prepend-icon": "search",
                              color: _vm.cor,
                              clearable: "",
                            },
                            on: {
                              input: function ($event) {
                                _vm.value.expandir = true
                              },
                            },
                            model: {
                              value: _vm.value.search,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "search", $$v)
                              },
                              expression: "value.search",
                            },
                          },
                          { ...onTooltip }
                        )
                      ),
                    ]
                  },
                },
              ]),
            },
            [_c("span", [_vm._v("Digite para pesquisar na lista")])]
          ),
        ],
        2
      ),
      _c(
        VSheet,
        {
          staticClass: "overflow-y-auto mt-12",
          attrs: { id: "scrolling-techniques-7", "max-height": "600" },
        },
        [
          _c(
            VContainer,
            { staticStyle: { height: "400px" } },
            [
              _c(VTreeview, {
                ref: "treeview",
                attrs: {
                  items: _vm.treeview,
                  "item-children": "filhos",
                  "open-all": _vm.value.expandir,
                  search: _vm.value.search,
                  filter: _vm.filter,
                  "selection-type": _vm.value.tipo,
                  "selected-color": _vm.cor,
                  color: _vm.cor,
                  dense: "",
                  selectable: "",
                  "return-object": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function ({ item }) {
                      return [
                        _vm._v(" " + _vm._s(item.nome) + " "),
                        _vm.isTodosOsFilhosSelecionados(item)
                          ? _c(
                              VTooltip,
                              {
                                attrs: { right: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on: onTooltip }) {
                                        return [
                                          _c(
                                            VBtn,
                                            _vm._g(
                                              {
                                                staticClass: "text-capitalize",
                                                attrs: {
                                                  color: "secondary",
                                                  text: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.selecionarFilhos(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              { ...onTooltip }
                                            ),
                                            [
                                              _c(
                                                VIcon,
                                                { staticClass: "mr-2" },
                                                [_vm._v("library_add_check")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", [
                                  _vm._v("Clique para remover a seleção"),
                                ]),
                              ]
                            )
                          : _c(
                              VTooltip,
                              {
                                attrs: { right: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on: onTooltip }) {
                                        return [
                                          _c(
                                            VBtn,
                                            _vm._g(
                                              {
                                                staticClass: "text-capitalize",
                                                attrs: {
                                                  color: "grey",
                                                  text: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.selecionarFilhos(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              { ...onTooltip }
                                            ),
                                            [
                                              _c(
                                                VIcon,
                                                { staticClass: "mr-2" },
                                                [_vm._v("queue")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", [
                                  _vm._v("Clique para selecionar todos abaixo"),
                                ]),
                              ]
                            ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.value.selecionado,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "selecionado", $$v)
                  },
                  expression: "value.selecionado",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }